export enum ContactViaEnum {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  BOTH = 'BOTH'
}

export const contactViaMapping: Record<ContactViaEnum, string> = {
  EMAIL: 'Par email',
  PHONE: 'Par téléphone',
  BOTH: 'Par email & téléphone'
}
